import React from 'react';

import dayjs from 'dayjs';
import {
  DatePicker as MaterialDatePicker,
  DatePickerProps as MaterialDatePickerProps,
  PickersDay,
} from '@mui/x-date-pickers';
import { mapError } from 'component/Form/mapError';
import { WrappedFieldProps } from 'redux-form';
import { DEFAULT_DATE_FORMAT } from 'shared/constants';
import { DistributiveOmit } from 'shared/utils/type';

import { BaseTextField } from './BaseTextField';

export type Props = WrappedFieldProps &
  DistributiveOmit<MaterialDatePickerProps<any, Date>, 'renderInput'> & {
    fullWidth?: boolean;
    clearable?: boolean;
    style?: React.CSSProperties;
    'data-testid'?: string;
  };

export const DatePicker = ({
  input: { onChange, value, ...inputProps },
  meta,
  onChange: onChangeDatePicker,
  fullWidth = true,
  clearable = false,
  style,
  ...props
}: Props) => {
  const { errorText } = mapError(meta, 'errorText');
  const datePickerValue = (value || props.value) ?? null;

  return (
    <MaterialDatePicker
      inputFormat={DEFAULT_DATE_FORMAT}
      {...inputProps}
      {...props}
      componentsProps={
        clearable
          ? {
              ...props.componentsProps,
              actionBar: {
                actions: (variant) =>
                  variant === 'desktop' ? ['clear'] : ['clear', 'cancel', 'accept'],
              },
            }
          : props.componentsProps
      }
      value={datePickerValue}
      onChange={(newValue, context) => {
        onChange(newValue);
        if (onChangeDatePicker) {
          onChangeDatePicker(newValue, context);
        }
      }}
      renderDay={(day, _selectedDates, pickersDayProps) => {
        const ariaLabel = dayjs(day).format('MMM D, YYYY'); // e.g. "Dec 16, 2022"
        return <PickersDay {...pickersDayProps} aria-label={ariaLabel} />;
      }}
      renderInput={(params: any) => {
        return (
          <BaseTextField
            {...params}
            data-testid={props['data-testid']}
            fullWidth={fullWidth}
            helperText={errorText}
            error={!!errorText}
            style={style}
          />
        );
      }}
    />
  );
};
